import { TableColumn } from "../../types/table-column";

export const AIDemandColumns: TableColumn[] = [
  {
    type: "string",
    fieldName: "AI_SCENARIO",
    value: "title",
    secondaryValue: "internalId",
    width: 50,
  },
  {
    type: "arrayIcons",
    fieldName: "USED_IN",
    value: "operations",
    width: 10,
  },
  {
    type: "arrayIcons",
    fieldName: "APPLICATION_AREAS",
    value: "areas",
    width: 10,
  },

  {
    type: "object",
    fieldName: "RISK",
    value: "riskLevel",
    width: 16,
  },

  {
    type: "string",
    fieldName: "RESPONSIBLE",
    value: "keyContact",
    width: 12,
  },
  {
    type: "release",
    fieldName: "RELEASE",
    value: "release",
    width: 5,
  },
  {
    type: "date",
    fieldName: "LAST_MODIFIED",
    value: "updatedAt",
    width: "fit-content",
  },
];
